const DmsUsers = {
    namespaced: true,
    state: {
        tab: 0,
        loading: false,
        dms_user: {
            country: null,
            region: null,
            town: null,
            roles: [{ id: null }],
            disabled_permissions: [],
            email: null,
            name: null,
            status: 'active',
            username: null,
            surname: null,
            forename: null,
            address: null,
            post_code: null,
            second_address: null,
            phone: null,
            fax: null,
            role: null,
            pharmacy_group_id: null,
            pharmacy_sites: [],
        },
        password: {
            password: null,
            new_password: null,
            new_password_confirmation: null,
        },
        errorMessages: {
            dms_user: {
                country: [],
                region: [],
                town: [],
                roles: [],
                disabled_permissions: [],
                email: [],
                username: [],
                status: [],
                surname: [],
                forename: [],
                address: [],
                post_code: [],
                second_address: [],
                phone: [],
                fax: [],
                role: [],
                pharmacy_group_id: [],
                pharmacy_sites: [],
            },
            password: {
                password: [],
                new_password: [],
                new_password_confirmation: [],
            },
        },
        pharmacySitesOptions: [],
        pharmacyGroupsOptions: [],
        townsOptions: [],
    },
    mutations: {
        SET_TAB(state, data) {
            state.tab = data;
        },
        SET_LOADING(state, loading) {
            state.loading = loading;
        },
        SET_DMS_USER_PROPERTY(state, data) {
            _.set(state, data.property, data.value);

            if (data.property === 'dms_user.pharmacy_group_id') {
                _.set(state, 'dms_user.pharmacy_group', data.value ? { id: data.value } : null);
                this.dispatch('dms_users/loadPharmacySitesOptions', { pharmacy_group_id: data.value });
            }
            // state.patient[data.property] = data.value;
        },
        REMOVE_DISABLED_PERMISSION(state, routeId) {
            _.remove(state.dms_user.disabled_permissions, (permissionId) => {
                return permissionId === routeId;
            });
        },
        PUSH_DISABLED_PERMISSION(state, routeId) {
            state.dms_user.disabled_permissions.push(routeId);
        },
        SET_PHARMACIES_SITES_OPTIONS(state, data) {
            state.pharmacySitesOptions = data;
        },
        ADD_PHARMACIES_SITES_OPTIONS(state, item) {
            const newItem = _.clone(item).map((x) => ({ name: x.site_name, id: x.id }));
            const updateList = _.clone(state.pharmacySitesOptions);
            updateList.push(...newItem);
            state.pharmacySitesOptions = updateList;
        },
        SET_PHARMACIES_GROUPS_OPTIONS(state, data) {
            state.pharmacyGroupsOptions = data;
        },
        ADD_PHARMACIES_GROUPS_OPTIONS(state, item) {
            const newItem = _.clone(item).map((x) => ({ name: x.group_name, id: x.id }));
            const updateList = _.clone(state.pharmacyGroupsOptions);
            updateList.push(...newItem);
            state.pharmacyGroupsOptions = updateList;
        },
        SET_DMS_USER(state, data) {
            state.dms_user = data;
        },
        SET_ERROR_MESSAGE(state, data) {
            _.set(state.errorMessages, data.property, data.value);
            // _.set(state, data.property, data.value);
        },
        SET_TOWNS_OPTIONS(state, data) {
            state.townsOptions = data;
        },
    },
    actions: {
        setLoading({ commit }, loading) {
            commit('SET_LOADING', loading);
        },
        changeTab({ commit }, tabIndex) {
            commit('SET_TAB', tabIndex);
        },
        updateProperty({ commit }, data) {
            commit('SET_DMS_USER_PROPERTY', data);
        },
        changePermissions({ commit }, { all, routeId }) {
            if (all.includes(routeId)) {
                commit('REMOVE_DISABLED_PERMISSION', routeId);
            } else {
                commit('PUSH_DISABLED_PERMISSION', routeId);
            }
        },
        async loadPharmacySitesOptions({ commit }, options = null) {
            return await axios
                .get(
                    route('api.v1.pharmacy-sites.options', {
                        sort: 'name',
                        pharmacy_group_id:
                            options && options.pharmacy_group_id ? `nin:${options.pharmacy_group_id}` : null,
                    })
                )
                .then((response) => {
                    const data = response.data.data;
                    commit('SET_PHARMACIES_SITES_OPTIONS', data);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        async loadPharmacyGroupsOptions({ commit }) {
            return await axios
                .get(
                    route('api.v1.pharmacy-groups.options', {
                        sort: 'name',
                        is_registered: 1,
                    })
                )
                .then((response) => {
                    const data = response.data.data;
                    commit('SET_PHARMACIES_GROUPS_OPTIONS', data);
                });
        },
        async loadTownsOptions({ commit }) {
            return await axios.get(route('api.v1.locations.towns.options')).then((response) => {
                const data = response.data.data;

                commit('SET_TOWNS_OPTIONS', data);
            });
        },
        setDmsUser({ commit }, data) {
            commit('SET_DMS_USER', data);
        },
        async loadDmsUser({ commit, state }, id) {
            commit('SET_LOADING', true);
            if (!id) {
                return _.delay(() => {
                    commit('SET_LOADING', false);
                }, 300);
            }
            return await axios
                .get(
                    route('api.v1.dms-users.show', {
                        dms_user: id,
                        fields: '*,pharmacy_group.id,pharmacy_group.group_name,pharmacy_group.is_registered,pharmacy_sites,roles.id,roles.*,has_all_sites_and_groups_deleted',
                    })
                )
                .then((response) => {
                    const data = response.data.data;
                    const pharmacySites = data.pharmacy_sites;
                    const pharmacyGroup = data.pharmacy_group;

                    data.pharmacy_group_id = pharmacyGroup ? pharmacyGroup.id : null;

                    commit('SET_DMS_USER', data);

                    if (!!pharmacySites && !state.pharmacySitesOptions.find((x) => x.id === pharmacySites.id)) {
                        commit('ADD_PHARMACIES_SITES_OPTIONS', pharmacySites);
                    }
                    if (!!pharmacyGroup && !state.pharmacyGroupsOptions.find((x) => x.id === pharmacyGroup.id)) {
                        commit('ADD_PHARMACIES_GROUPS_OPTIONS', [pharmacyGroup]);
                        data.pharmacy_group_id = pharmacyGroup.id;
                    }
                })
                .finally(() => {
                    _.delay(() => {
                        commit('SET_LOADING', false);
                    }, 300);
                });
        },
        resetErrorMessages({ commit, state }) {
            _.each(state.errorMessages, function (messages, field) {
                const vueObjectToPlain = JSON.parse(JSON.stringify(state.errorMessages[field]));
                if (_.isPlainObject(vueObjectToPlain)) {
                    _.each(state.errorMessages[field], function (messages, plainObjectField) {
                        commit('SET_ERROR_MESSAGE', { value: [], property: `${field}.${plainObjectField}` });
                    });
                } else {
                    commit('SET_ERROR_MESSAGE', { value: [], property: field });
                }
            });
        },
        setErrorMessage({ commit }, data) {
            commit('SET_ERROR_MESSAGE', data);
        },
        setErrorMessages({ commit, state }, data) {
            const errors = data.type ? data.errors : data;
            const propertyToAdd = data.type ? 'password' : 'dms_user';
            _.each(errors, function (fieldErrors) {
                const errorMessageField = _.get(state.errorMessages, `${propertyToAdd}.${fieldErrors.field}`);

                let mappedErrors;
                if (fieldErrors.field === 'roles') {
                    mappedErrors = fieldErrors.errors.map(() => 'The Role field is required.');
                }

                if (fieldErrors.field && errorMessageField !== undefined) {
                    commit('SET_ERROR_MESSAGE', {
                        value: mappedErrors || fieldErrors.errors,
                        property: `${propertyToAdd}.${fieldErrors.field}`,
                    });
                }
            });
        },
    },
};

export default DmsUsers;
